import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import Bottom from '@/images/position/align/Bottom.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { alignElementsBottom } from '../../../../actions/align/Bottom';

export const BottomMenuItem = () => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        alignElementsBottom(store, selectedElements);
    };

    return <MenuItemIcon onClick={handleClick} src={Bottom} text="Bottom" />;
};
